import { useEffect, useRef } from 'react';

import { FormikValues } from 'formik/dist/types';

import { useDebounce } from '../../../../hooks/useDebounce';

function isSameRelevantValues(
  current: FormikValues,
  prev: FormikValues,
): boolean {
  if (current.status !== prev.status || current.type !== prev.type) {
    return false;
  }
  const currOpts = current.trainingSetItemOptions ?? [];
  const prevOpts = prev.trainingSetItemOptions ?? [];
  if (currOpts.length !== prevOpts.length) return false;
  return currOpts.every(
    (option, i) =>
      option.value === prevOpts[i]?.value &&
      option.value2 === prevOpts[i]?.value2,
  );
}

function isStatusChanged(current: FormikValues, prev: FormikValues): boolean {
  return current.status !== prev.status;
}

export function useCurrentTrainingDebounce(formik: FormikValues) {
  const [debouncedSubmit, cancelDebounce] = useDebounce(
    formik.submitForm,
    1000,
  );
  const prevValuesRef = useRef(formik.values);

  useEffect(() => {
    const current = formik.values;
    const prev = prevValuesRef.current;
    if (!isSameRelevantValues(current, prev)) {
      const submitImmediately = isStatusChanged(current, prev);
      prevValuesRef.current = current;

      if (submitImmediately) {
        cancelDebounce();
        formik.submitForm();
      } else {
        debouncedSubmit();
      }
    }
  }, [formik.values, debouncedSubmit, cancelDebounce]);
}
